import leftarroicn from "../../../assets/images/leftarroicn.svg";
import Loader from "../../../common/loader/Loader";
import { useState } from "react";
import { useEffect } from "react";
import { Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
// Core viewer
import { Viewer } from "@react-pdf-viewer/core";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { useSelector } from "react-redux";
import Button from "../../form-components/Button";
import editImg from "../../../assets/images/edit_project.svg";
import trashImg from "../../../assets/images/trash.svg";
import ConfirmationModal from "../../../common/modal/ConfirmationModal";
// import CreateEditorDocumentModal from "../CreateEditorDocument";

const FilePreviewModal = ({
    title,
    src,
    type,
    sourceType,
    textTitle,
    textDescription,
    setDocUrl,
    subCategories,
    setSubCategories = () => { },
    setEditUUID = () => { },
    uuid,
    setUuid = () => { },
    perPage = 10,
    currentPage = 1,
    extension,
    currentModal,
    setCurrentModal,
    toggleModal,
    handleDelete,
    setIsFromFilePreview,
    previousSubCategories,
}) => {

    const {
        documentPreviewLoading = false,
    } = useSelector((state) => ({
        documentPreviewLoading: state?.getSingleDocument?.isLoading,
    }));
    /* let [loading, setLoading] = useState(true); */
    /*  useEffect(() => {
         if (type !== 'doc' || extension === 'pdf') {
             setLoading(false)
         } else {
             setLoading(true)
         }
     }, [type, extension]) */
    /* const handleLoad = () => {
        setLoading(false);
    } */

    const toolbarPluginInstance = toolbarPlugin();
    const { Toolbar } = toolbarPluginInstance;
    const hideEditSourceTypes = ["sitemap", "rss_feed", "single_page"];
    
    return (
        documentPreviewLoading ? <Loader />
            :
            <div className="content-right-box">
                <div className="intro-table-search container-fluid">
                    <div className="row align-items-center py-3">
                        <div className="col-12 col-md-12 col-xl-12">
                            <div className="right-divpr d-flex align-items-center">
                                <img className="intro-icn me-2 cursor-pointer" src={leftarroicn} alt="leftarroicn" onClick={() => { setSubCategories(previousSubCategories); setEditUUID(''); setUuid(""); setDocUrl(''); }} />
                                <h3 className="modal-title me-auto" id="Add_OrganizationLabel">{type === 'doc' ? title : textTitle}</h3>
                                {type === "text" &&
                                    <>
                                        {previousSubCategories !== "Archive" && !hideEditSourceTypes.includes(sourceType) && (
                                            <Button
                                                type="button"
                                                className="btn create-doc-btn mt-0 edit-svgimg-btn"
                                                onClick={() => { setSubCategories("createNewDoc"); setIsFromFilePreview(true); }}
                                            >
                                                <img src={editImg} alt="edit" />
                                                Edit
                                            </Button>
                                        )}
                                        <Button
                                            type="button"
                                            className={`btn btn-danger-md trash-btn ${previousSubCategories === "Archive" ? "ms-auto" : "ms-2"}`}
                                            onClick={() => { setCurrentModal("deleteDocModal"); setIsFromFilePreview(true); }}
                                        >
                                            <img src={trashImg} className="me-2" alt="edit" />
                                            Delete
                                        </Button>
                                    </>
                                }
                                {/* <button type='button' className='btn d-flex dlet-btn me-2'><img src="/static/media/trash.72657b09efa409e79727b60dd2c7bc45.svg" alt="" />
                            </button> */}
                            </div>
                            {/* <h5 className="intro-title d-flex align-items-center">
                  <img className="intro-icn me-2" src={leftarroicn} alt="leftarroicn" onClick={() => { setSubCategories("Documents");}} />
                  {type === 'doc' ? title : textTitle}
                </h5> */}
                        </div>
                        <div className="col-12 col-md-6 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
                            <div className="">
                                {/* <Button type="button" disabled={isLoading || isLoadingEditData} className="btn btn-primary-md" onClick={() => createNewDoc()}>Save</Button> */}
                            </div>
                        </div>
                    </div>
                    {/* {loading === true ? <Loader /> : ''} */}
                    {(type === 'doc') && <div
                        className="rpv-core__viewer p-0"

                    >
                        <div
                            className="prev-tools"
                        >
                            <Toolbar />
                        </div>
                        <div
                            className="prev-scroll"
                        >
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
                                <Viewer
                                    /* initialPage={1} */
                                    fileUrl={src}
                                    plugins={[toolbarPluginInstance]}
                                />
                            </Worker>
                        </div>
                    </div>}
                    <div className="newdoc-form">
                        {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
                                    <Viewer
                                      initialPage={1}
                                      fileUrl={src}
                                      plugins={[toolbarPluginInstance]}
                                    />
                                  </Worker> */}
                        {/* {(type === 'doc' && (extension === 'doc' || extension === 'docx')) &&
                        <>
                            <iframe
                                src={"https://view.officeapps.live.com/op/embed.aspx?src=" + urlEncode + "&embedded=true"}
                                title="file"
                                width="100%"
                                height="600"
                                loading="lazy"
                                onLoad={handleLoad}
                                frameborder='0'
                            />
                        </>
                    } */}
                        {(type === 'text') &&
                            <div className="iframe-div">
                                {/* <div className="rpv-core__viewer" dangerouslySetInnerHTML={{ __html: textDescription }} /> */}
                                <iframe className="rpv-core__viewer" srcDoc={textDescription} />
                            </div>
                        }
                    </div>
                </div>
                {/* {subCategories === "createNewDoc" && (
                    <CreateEditorDocumentModal
                        setSubCategories={setSubCategories}
                        perPage={perPage}
                        currentPage={currentPage}
                        editUUID={uuid}
                        setEditUUID={setUuid}
                        isFromFilePreview={true}
                        previousSubCategories={previousSubCategories}
                    />
                )} */}
                {currentModal === "deleteDocModal" && (
                    <ConfirmationModal
                        title={"Delete Confirmation"}
                        isOpen={currentModal === "deleteDocModal"}
                        toggle={toggleModal}
                        onConfirm={handleDelete}
                        message="Are you sure you want to delete this document?"
                    />
                )}
            </div>
    )
}

export default FilePreviewModal;
